'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMockTask = createMockTask;

var _utils = require('./utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createMockTask() {
  var _ref;

  var running = true;
  var _result = undefined,
      _error = undefined;

  return _ref = {}, _defineProperty(_ref, _utils.TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
    return running;
  }), _defineProperty(_ref, 'result', function result() {
    return _result;
  }), _defineProperty(_ref, 'error', function error() {
    return _error;
  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
    return running = b;
  }), _defineProperty(_ref, 'setResult', function setResult(r) {
    return _result = r;
  }), _defineProperty(_ref, 'setError', function setError(e) {
    return _error = e;
  }), _ref;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/lib/internal/testUtils.js
// module id = 1290
// module chunks = 34